<template>
    <div class="mb-50">
        <div class="request-status-block">
            <ul class="list-inline">
                <li class="list-inline-item">
                    <h1> Coach</h1>
                </li>
            </ul>
        </div>
        <b-row>
            <b-col md="12">
                <div class="card">
                    <div class="card-body">
                        <h3>Request</h3>
                        <label class="ask-header">Subject</label>
                        <p v-text="ask.subject"></p>
                        <!-- <p v-text="ask.subject" v-if="setStatus(ask.status) == 'Closed'"></p>
                        <div v-else >
                            <input name="subject" type="text" placeholder="Enter subject" v-model.trim="ask.subject" class="form-control">
                            <p></p>
                        </div> -->
                        <label class="ask-header">Description</label>
                        <p class="md-justify" v-text="ask.text"></p>
                        <!-- <p class="md-justify" v-text="ask.text" v-if="setStatus(ask.status) == 'Closed'"></p>
                        <b-form-textarea name="text" placeholder="Enter description" rows="14" v-model.trim="ask.text" v-else class="form-control md-justify"></b-form-textarea> -->
                    </div>
                </div>
            </b-col>
        </b-row>
        <b-row>
            <b-col md="12">
                <div class="d-flex justify-content-start mb-2">
                    <b-dropdown text="Choose Template" variant="secondary" menu-class="dropdown-menu" dropright>
                        <b-dropdown-header id="dropdown-header-label">
                            Insert template
                        </b-dropdown-header>
                        <b-dropdown-item-button v-for="template in templates" :key="template._id"
                            @click="insertTemplate(template)">
                            {{ template.name }}
                        </b-dropdown-item-button>
                        <b-dropdown-divider></b-dropdown-divider>
                       <b-dropdown-item-button @click="openSaveNewTemplateModal">
                            Save draft as template
                        </b-dropdown-item-button>   
                    </b-dropdown>
                    <b-dropdown text="Delete template" menu-class="dropdown-menu" dropright class="ml-2">
                        <b-dropdown-header id="dropdown-header-label">
                                Delete template
                        </b-dropdown-header>
                            <b-dropdown-item 
                                v-for="template in templates" 
                                :key="template._id + '-delete'"
                                @click="deleteTemplate(template)">
                                {{ template.name }}
                            </b-dropdown-item>
                        </b-dropdown>
                </div>
                <div class="card">
                    <div class="card-body">
                        <b-form-textarea name="text" placeholder="Enter description" rows="14" v-model.trim="coach"
                            class="form-control md-justify"
                           @blur="coach = sanitizeHtmlTemplate($event.target.value || coach)"></b-form-textarea>
                   </div>
                    <div class="card-body">
                        <div class="mb-3 mt-1">
                            <b-form-checkbox v-model="keepOpen">
                                Keep this request active after coaching
                            </b-form-checkbox>
                        </div>
                        <ul class="list-inline">
                            <li class="list-inline-item">
                                <button type="button" class="btn custom-card-header-filter btn-dropbox tab-focus"
                                    @click="coachRequest()" :disabled="!coach">
                                    Submit
                               </button>
                            </li>
                            <li class="list-inline-item">
                                <button type="button" class="btn custom-card-header-filter btn-cancel tab-focus"
                                    @click="$router.push(`/`)">Cancel</button>
                            </li>
                        </ul>
                    </div>
                </div>
            </b-col>
        </b-row>
            <b-modal
            v-model="showTemplateModal"
            title="Save as New Template"
            @ok="saveDraftAsTemplate"
            :ok-disabled="!templateName.trim()"
            >
            <b-form-group label="Template Name">
                <b-form-input
                v-model="templateName"
                placeholder="Enter template name"
                :state="templateNameTouched ? templateName.trim().length > 0 : null"
                @blur="templateNameTouched = true"
                ></b-form-input>
                <b-form-invalid-feedback v-if="templateNameTouched && !templateName.trim()">
                Template name is required.
                </b-form-invalid-feedback>
            </b-form-group>
            <b-form-group v-if="userRole === 'SuperAdmin'" label="Global Template">
                <b-form-checkbox v-model="isGlobalTemplate">
                Mark as global template
                </b-form-checkbox>
            </b-form-group>
            </b-modal>
    </div>
</template>

<script>
import axios from 'axios';
import { parseJwt } from '@/helpers/jwt';
import { setRequestStatus } from '@/assets/js/set-status';
import VueNotifications from 'vue-notifications'
import { sanitizeHtmlTemplate } from '@/utils/sanitizer'

export default {
    name: 'RequestCoachView',
    data() {
        return {
            keepOpen: false,
            templateNameTouched: false,
            isGlobalTemplate: false,
            userRole: '',
            templates: [],
            ask: {},
            token: '',
            authUser: {},
            coach: '',
            showTemplateModal: false,
            templateName: '',
        }
    },
    notifications: {
        showSuccessMsg: {
            type: VueNotifications.types.success
        }
    },
    created() {
        this.token = localStorage.getItem('token');
        if(this.token){
            const decoded = parseJwt(this.token);
            this.userRole = decoded && decoded.role ? decoded.role : "Admin"
        }
        const user = localStorage.getItem('authUser');
        if (user) {
            this.authUser = JSON.parse(user);
        }
        this.loadData();
    },
    methods: {
        loadData: async function() {
            await this.axios.get(process.env.VUE_APP_API_BASE_URL + `/asks/${this.$route.params.request_id}`, {headers: {'x-access-token': this.token}}).then(request => {
                this.ask = request.data;
                if (setRequestStatus( this.ask.status) != 'In Review' && setRequestStatus( this.ask.status) != 'Active') {
                    this.$router.push('/');
                }
                if (this.ask && this.ask.community && this.ask.community.content && this.ask.community.content.coach) {
                    this.coach =  this.ask.community.content.coach;
                }
                this.loadTemplates();
            });
        },
        loadTemplates: async function() {
            try {
                const response = await axios.get(`${process.env.VUE_APP_API_BASE_URL}/dashboard/dashboard-templates/`, {
                    params: {
                        type: 'community',
                    },
                    headers: {
                        'x-access-token': this.token
                    }
                });
                this.templates = response.data.data;
            } catch (err) {
                console.error("Error loading templates:", err);
            }
        },
        deleteTemplate: async function(template){
            if(!template || !template._id) {
                return;
            }
            try {
                await axios.post(`${process.env.VUE_APP_API_BASE_URL}/dashboard/dashboard-templates/${template._id}`, 
                {
                        ...template,
                },
                {
                    headers: {
                        'x-access-token': this.token,
                    }
                });
                this.templates = this.templates.filter(t => t._id !== template._id);
            } catch (err) {
                console.error("Error deleting template:", err);
            }
        },
        openSaveNewTemplateModal: function() {
            this.templateName = '';
            this.showTemplateModal = true;
            this.templateNameTouched = false;
        },
        insertTemplate: function(template) {
            if (template && template.content) {
                this.coach = this.sanitizeHtmlTemplate(template.content);
            }
        },
        setStatus: function(status) {
            return setRequestStatus(status);
        },
        sanitizeInput(input) {
            return sanitizeInput(input);
        },
        sanitizeHtmlTemplate(input) {
            return sanitizeHtmlTemplate(input);
        },
        saveDraftAsTemplate: async function () {
            if (!this.coach || this.templateName === '') {
                return;
            }
            try {
                const type = (this.userRole === 'SuperAdmin' && this.isGlobalTemplate) ? 'global' : 'community';
                const response = await axios.post(`${process.env.VUE_APP_API_BASE_URL}/dashboard/dashboard-templates/`,
                {
                    name: this.templateName,
                    content: this.sanitizeHtmlTemplate(this.coach),
                    type: type, 
                },
                {
                    headers: {
                        'x-access-token': this.token,
                        'Content-Type': 'application/json'
                    }
                }
            );
                this.templates.push(response.data.data);
                this.showTemplateModal = false;
                this.isGlobalTemplate = false; 
                this.showSuccessMsg({ message: 'Template created successfully!'});
            } catch (err) {
                console.error("Error saving draft as template:", err);
            }
        },
        coachRequest: function () {
            const sanitized = this.sanitizeHtmlTemplate(this.coach);
            const action = this.keepOpen
                ? 'coach_only'
                : (setRequestStatus(this.ask.status) == 'In Review' ? 'reject' : 'close');
            let params = {
                askId: this.ask._id,
                action: action,
                status: this.keepOpen ? 'coach_only' : 'coach',
                approvedBy: 'dashboard',
                coachMsg: sanitized
            }
            if (this.authUser.memberID) {
                params.adminId = this.authUser.memberID;
            }
            this.axios.post(`${process.env.VUE_APP_API_BASE_URL}/dashboard/request-approval`, params, { headers: { 'x-access-token': this.token } })
                .then(async response => {
                    this.showSuccessMsg({ message: 'Request coached successfully' });

                    const query = this.$route.query;
                    if (query.from == 'request-detail-page') {
                        this.$router.push(`/engagement/requests/${this.ask._id}`);
                    } else if (query.from == 'request-page') {
                        this.$router.push('/engagement/requests');
                    } else if (query.from == 'request-approval-page') {
                        this.$router.push('/engagement/requests-approval');
                    } else {
                        this.$router.push('/engagement/requests');
                    }
                }).catch(err => {
                    if (err.response.status === 401) {
                        localStorage.removeItem('authUser');
                        this.$router.push('/login');
                    }
                });
        }
    }
}
</script>
<style>
.dropdown-menu {
    align-items: center !important;
    align-content: center !important;
}

.delete-dropdown-menu.show {
  top: 0 !important;
  left: 100% !important;
  margin-top: 8px;
}
</style>